import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';

import { ClientDetailsState, ClientDetailsStore } from './client-details.store';
import { ClientDetails } from '@core/models/client-details.model';

@Injectable({ providedIn: 'root' })
export class ClientDetailsQuery extends QueryEntity<ClientDetailsState> {
  constructor(protected store: ClientDetailsStore) {
    super(store);
  }

  // TODO: fix to dynamically update
  isEligibleParty(): boolean {
    return true;
  }

  isLicensed(): boolean {
    return (this.getActive() as ClientDetails)?.investorClientAdviceLicence;
  }
}
